import { lazy, Suspense } from 'react';
import MainHeader from '@/components/MainHeader';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import HeroSection from '@/components/HeroSection';
import SEOHead from '@/components/SEOHead';
import { OrganizationSchema, WebSiteSchema, LocalBusinessSchema } from '@/components/SchemaOrg';
import { Skeleton } from '@/components/ui/skeleton';

// Lazy load below-the-fold sections
const ServicesSection = lazy(() => import('@/components/ServicesSection'));
const ProductsSection = lazy(() => import('@/components/ProductsSection'));

const SectionLoader = () => (
  <section className="bg-primary py-12 px-4">
    <div className="container mx-auto">
      <Skeleton className="h-8 w-64 mb-10 bg-primary-foreground/20" />
      <div className="grid md:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} className="aspect-[4/3] rounded-xl bg-primary-foreground/20" />
        ))}
      </div>
    </div>
  </section>
);

const Index = () => {
  return (
    <>
      <SEOHead
        title="Materiali DTF Professionali | Inchiostri, Bobine, Colla | Materialidtf.it"
        description="Scopri la migliore selezione di materiali per stampa DTF professionale in Italia: inchiostri, bobine, colla, polvere adesiva e ricambi. Assistenza tecnica e profilatura ICC."
        canonical="/"
        keywords="materiali DTF, inchiostri DTF, bobine DTF, colla DTF, stampa DTF, polvere adesiva DTF, ricambi stampanti DTF, profilatura ICC"
      />
      <OrganizationSchema />
      <WebSiteSchema />
      <LocalBusinessSchema />
      
      <div className="min-h-screen flex flex-col">
        <MainHeader />
        <Navigation />
        
        <main className="flex-1">
          <HeroSection />
          <Suspense fallback={<SectionLoader />}>
            <ServicesSection />
          </Suspense>
          <Suspense fallback={<SectionLoader />}>
            <ProductsSection />
          </Suspense>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default Index;